/**
 * @generated SignedSource<<5f2486ecffbf2436d8c6692b54981a57>>
 * @relayHash 787705fbe9a0fe66d25b583a45238e34
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 787705fbe9a0fe66d25b583a45238e34

import { ConcreteRequest } from 'relay-runtime';
export type Ch_deleteNutritionalPrescriptionInput = {
  id: string;
};
export type useChDeleteNutritionalCounsellingMutation$variables = {
  input: Ch_deleteNutritionalPrescriptionInput;
};
export type useChDeleteNutritionalCounsellingMutation$data = {
  readonly ch_deleteNutritionalPrescription: {
    readonly ch_NutritionalPrescription: {
      readonly id: string;
    } | null;
  };
};
export type useChDeleteNutritionalCounsellingMutation = {
  response: useChDeleteNutritionalCounsellingMutation$data;
  variables: useChDeleteNutritionalCounsellingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChDeleteNutritionalCounsellingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteNutritionalPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteNutritionalPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NutritionalPrescription",
            "kind": "LinkedField",
            "name": "ch_NutritionalPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChDeleteNutritionalCounsellingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_deleteNutritionalPrescriptionPayload",
        "kind": "LinkedField",
        "name": "ch_deleteNutritionalPrescription",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_NutritionalPrescription",
            "kind": "LinkedField",
            "name": "ch_NutritionalPrescription",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "787705fbe9a0fe66d25b583a45238e34",
    "metadata": {},
    "name": "useChDeleteNutritionalCounsellingMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ecc8175d396d34de8a4bc79de99e2e1c";

export default node;
